export const calculateGroupSellingPrice = (items) => {
  const expenseActivitiesSellingPrice = items
    .filter(({ type }) => type === 'expense-activity')
    .reduce(
      (prevValue, currValue) =>
        prevValue + parseFloat(currValue.sellingPrice || 0),
      0
    )

  const timeActivitiesSellingPrice = items
    .filter(({ type }) => type === 'time-activity')
    .reduce(
      (prevValue, currValue) => prevValue + parseFloat(currValue.total || 0),
      0
    )

  return expenseActivitiesSellingPrice + timeActivitiesSellingPrice
}

export const useSmallText = (phase, totalInvoicedByActuals) =>
  phase.total >= 99999 ||
  phase.spentAmount >= 99999 ||
  phase.sellingPrice >= 99999 ||
  totalInvoicedByActuals >= 99999
